import React, { useRef, useState } from 'react';
import palyBtn from '@gp/assets/svg/icon-video-play.svg';
// import palyBtnPause from '@gp/assets/svg/icon-video-pause.svg';
import GeneralImageNew from '@gp/components/GeneralImageNew';
import swiperDefault from '@/pages/home/assets/img/common/swiper-default.png';
import { splitFileName } from '@gp/utils/common';
import './index.scss';

const VideoImgContent = (props: any) => {
  const { data = {}, isLeftList = false } = props;
  const { name, type, img, resource_url: src, resource_cover: cover } = data;
  const videos = useRef(null);
  const [showPlayBtn, setShowPlayBtn] = useState(true);

  return (
    <div
      className="dbg-project-detail-visual-showcase-datas-single-item-box"
      title={splitFileName(name)?.fileSuffixName || '-'}
    >
      {type === 2 ? (
        <div
          className="dbg-project-detail-visual-content-video"
          style={{
            backgroundSize: 'cover',
            backgroundPosition: 'center',
            borderRadius: '8px',
          }}
        >
          <video
            id={'myVideo'}
            src={src}
            controls={isLeftList ? false : !showPlayBtn}
            ref={videos}
            onPlay={() => {
              setShowPlayBtn(false);
            }}
            // onPause={() => {
            //   setShowPlayBtn(true);
            // }}
            poster={isLeftList ? cover : !showPlayBtn ? undefined : cover}
          ></video>
          <div
            style={{ display: showPlayBtn ? 'block' : 'none' }}
            className="play-btn-box"
            onClick={() => {
              if (!isLeftList) {
                videos.current?.play();
              }
            }}
          >
            <img className="item-play-icon" src={palyBtn} />
          </div>
        </div>
      ) : (
        <div className="dbg-project-detail-visual-content-img" style={{ height: '100%' }}>
          <GeneralImageNew src={src || img} width={84} height={42} errorImg={swiperDefault} needBorderRadius={false} />
        </div>
      )}
    </div>
  );
};

export default VideoImgContent;
